module.exports = __webpack_public_path__ + "img/comp_benchmark.fdc542f8.jpg";